import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number | string
}

export const NeurodiversityCOEIllustration: FunctionComponent<Props> = ({ size = 45 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 45 45'>
      <Path
        d='M22.669.156c-3.106 0-6.12.533-8.958 1.583C6.956 4.243 2.206 9.795.681 16.97c-1.009 4.679-.88 9.006.396 13.223 1.63 5.385 5.628 9.926 10.972 12.459 2.652 1.26 5.7 1.98 9.056 2.138.431.02.87.03 1.305.03 2.693 0 5.401-.37 8.051-1.096.204-.051.398-.104.602-.164 2.382-.697 4.525-1.8 6.359-3.274 1.99-1.59 3.63-3.607 4.866-5.99.243-.47.476-.964.733-1.556 1.414-3.283 2.097-6.958 1.976-10.632-.057-1.625-.299-3.352-.717-5.138-.688-2.897-1.81-5.621-3.245-7.884a21.912 21.912 0 00-1.112-1.576c-2.58-3.328-6.6-5.663-11.62-6.75A26.62 26.62 0 0022.67.157h-.001z'
        fill='#FFE9E3'
      />
      <Path
        d='M19.934 21.056c.815.03 1.565.112 2.253.24.057-.028.115-.055.175-.078.9-.355 1.974-.782 3.003-1.194-.687-.55-1.427-1.22-1.87-2.206-.862-1.924.997-3.685 4.55-2.829-1.39-1.96-4.39-3.648-10.863-1.623-11.63 3.64-7.87 12.461-2.706 13.234-.697-2.467.434-5.725 5.458-5.544z'
        fill='#C2E599'
      />
      <Path
        d='M24.953 27.046c.344-2.06 1.052-2.988 1.551-3.841-1.032-.88-2.445-1.563-4.317-1.909-2.476 1.188-2.13 5.742-7.352 5.346a4.66 4.66 0 01-.358-.04c.235.831.677 1.574 1.249 2.063 2.266 1.943 6.475.486 7.609 3.4 1.133 2.914 3.076 3.318 3.076 3.318 1.78-.27 2.23-1.655 2.356-3.58a8.72 8.72 0 01-.818-.143c-3.238-.728-2.995-4.614-2.995-4.614z'
        fill='#FFAF9B'
      />
      <Path
        d='M22.189 21.295a15.39 15.39 0 00-2.253-.239c-5.024-.181-6.155 3.078-5.458 5.545.119.018.238.031.358.04 5.222.396 4.876-4.157 7.353-5.346z'
        fill='#FFC03C'
      />
      <Path
        d='M30.62 15.957c-.933-.467-1.795-.78-2.575-.968.222.313.403.633.55.946a2.45 2.45 0 01-1.303 3.317l-1.927.772c.95.76 1.799 1.286 1.611 2.084-.094.403-.266.744-.473 1.096 1.716 1.463 2.379 3.47 2.335 5.38-.027 1.16-.009 2.257-.072 3.219 2.842.36 5.033-.914 6.143-3.948 1.214-3.318.89-9.308-4.29-11.898z'
        fill='#85CCD5'
      />
      <Path
        d='M23.496 17.819c.442.984 1.182 1.656 1.87 2.205l1.926-.772a2.45 2.45 0 001.303-3.316 6.242 6.242 0 00-.55-.947c-3.553-.856-5.411.904-4.548 2.829h-.001z'
        fill='#3BA5B5'
      />
      <Path
        d='M26.505 23.204c-.5.853-1.207 1.78-1.552 3.841 0 0-.242 3.885 2.995 4.614.279.063.552.11.819.144.062-.962.045-2.06.071-3.22.045-1.909-.617-3.916-2.334-5.379z'
        fill='#F69170'
      />
    </Svg>
  )
}
